import AnalysisNoPc from '@/views/pt/class-analysis/components/no-pc.vue';
import ClassHome from '@/views/pt/class-analysis/components/study-home.vue';
import ClassCompareReport from '@/views/pt/class-compare-report.vue';
import ClassReport from '@/views/pt/class-report.vue';
import CreateTestSuccess from '@/views/pt/create-test-success.vue';
import CreateTest from '@/views/pt/create-test.vue';
import CreateWeakSpot from '@/views/pt/create-weakspot.vue';
import Detailed from '@/views/pt/detailed.vue';
import ExportTest from '@/views/pt/export-test.vue';
import Home from '@/views/pt/index.vue';
import NewDetailed from '@/views/pt/new-detailed.vue';
import TestCenter from '@/views/pt/test-center.vue';
import TestRecord from '@/views/pt/test-record.vue';
import ExerciseAnalyze from '@/views/pt/exercise-center/exercise-analyze.vue';
import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  // 首页
  {
    path: '/pt',
    name: 'Home',
    component: Home,
    meta: {
      permission: false,
    },
  },
  // 测评中心
  {
    path: '/pt/test-center',
    name: 'TestCenter',
    component: TestCenter,
    meta: {
      permission: false,
    },
  },
  // 创建测评
  {
    path: '/pt/create-test',
    name: 'CreateTest',
    component: CreateTest,
    meta: {
      permission: false,
    },
  },
  // 创建测评成功
  {
    path: '/pt/create-test-success',
    name: 'CreateTestSuccess',
    component: CreateTestSuccess,
    meta: {
      permission: false,
    },
  },
  //  巩固练习记录
  {
    path: '/pt/test-record',
    name: 'TestRecord',
    component: TestRecord,
    meta: {
      permission: false,
    },
  },
  // 单个知识点明细
  {
    path: '/pt/detailed',
    name: 'Detailed',
    component: Detailed,
    meta: {
      permission: false,
    },
  },
  // 新知识点明细
  {
    path: '/pt/new-detailed',
    name: 'NewDetailed',
    component: NewDetailed,
    meta: {
      permission: false,
    },
  },
  // 班级报告
  {
    path: '/pt/class-report',
    name: 'ClassReport',
    component: ClassReport,
    meta: {
      permission: false,
    },
  },
  // 班级对比报告
  {
    path: '/pt/class-compare-report',
    name: 'ClassCompareReport',
    component: ClassCompareReport,
    meta: {
      permission: false,
    },
  },
  // 创建知识点练习
  {
    path: '/pt/create-weakspot',
    name: 'CreateWeakSpot',
    component: CreateWeakSpot,
    meta: {
      permission: false,
    },
  },
  // 练习导出
  {
    path: '/pt/export-test',
    name: 'ExportTest',
    component: ExportTest,
    meta: {
      permission: false,
    },
  },
  // 备课页面
  {
    path: '/pt/lesson-prepare',
    name: 'LessonPrepare',
    component: () => import(/* webpackChunkName: "LessonPrepare" */'@/views/pt/lesson-prepare/index.vue'),
  },
  // 班级预习报告页面
  {
    path: '/pt/lesson-prepare/class-report-detail',
    name: 'ClassReportDetail',
    component: () => import(/* webpackChunkName: "LessonPrepare" */'@/views/pt/lesson-prepare/class-report-detail.vue'),
  },
  // 班级学情分析页面
  {
    path: '/pt/class-analysis',
    name: 'ClassAnalysis',
    component: () => import('@/views/pt/class-analysis/index.vue'),
  },
  {
    path: '/pt/class-analysis/classHome',
    name: 'ClassHome',
    component: ClassHome,
  },
  {
    path: '/pt/class-analysis/AnalysisNoPc',
    name: 'AnalysisNoPc',
    component: AnalysisNoPc,
  },
  // 个人学情分析列表页
  {
    path: '/pt/person-analysis',
    name: 'PersonAnalysis',
    component: () => import('@/views/pt/person-analysis/index.vue'),
  },
  // 个人学情分析详情页
  {
    path: '/pt/home-analysis',
    name: 'HomeAnalysis',
    component: () => import('@/views/pt/person-analysis/components/home-analysis.vue'),
  },
  // 精准教学驾驶舱
  {
    path: '/pt/cockpit-exhibition',
    name: 'Cockpit',
    component: () => import('@/views/pt/cockpit-exhibition/index.vue'),
  },
  // 精准教学驾驶舱
  {
    path: '/pt/cockpit',
    name: 'Cockpit',
    component: () => import('@/views/pt/cockpit/index.vue'),
  },
  // 精准教学测评分析暂用
  {
    path: '/pt/class-analysis/analysis-overview',
    name: 'AnalysisOverview',
    component: () => import('@/views/pt/class-analysis/components/analysis-overview.vue'),
  },
  // 视屏讲义, 暂时用
  {
    path: '/pt/lesson-prepare/video-lectures',
    name: 'VideoLectures',
    component: () => import('@/views/pt/lesson-prepare/components/video-lectures.vue'),
  },
  // 题目资源, 暂时用
  {
    path: '/pt/lesson-prepare/topic-resource',
    name: 'TopicResource',
    component: () => import('@/views/pt/lesson-prepare/components/topic-resource.vue'),
  },
  // 练习中心
  {
    path: '/pt/exercise-center',
    name: 'ExerciseCenter',
    component: () => import(/* webpackChunkName: "exercise-center" */ '@/views/pt/exercise-center/index.vue'),
  },
  // 共性分析
  {
    path: '/pt/exercise-analyze',
    name: 'ExerciseAnalyze',
    component: ExerciseAnalyze,
    meta: {
      isUseCache: false,
    },
  },
  // 共性分析
  {
    path: '/pt/exercise-type-analyze',
    name: 'ExerciseTypeAnalyze',
    component: () => import(/* webpackChunkName: "exercise-analyze" */ '@/views/pt/exercise-center/exercise-analyze.vue'),
  },
  // 智适应
  {
    path: '/pt/create-at',
    name: 'CreateAt',
    component: () => import(/* webpackChunkName: "create-at" */ '@/views/pt/exercise-center/create-at.vue'),
    meta: {
      isUseCache: false,
    },
  },
  {
    path: '/pt/create-mt',
    name: 'CreateMt',
    component: () => import(/* webpackChunkName: "create-mt" */ '@/views/pt/exercise-center/create-mt.vue'),
    meta: {
      isUseCache: false,
    },
  },
  // 老师报告
  {
    path: '/pt/teacher-report',
    name: 'TeacherReport',
    component: () => import(/* webpackChunkName: "teacher-report" */ '@/views/pt/teacher-report/index.vue'),
  },
  // 练习概览
  {
    path: '/pt/exercise-content',
    name: 'ExerciseContent',
    component: () => import(/* webpackChunkName: "teacher-report" */ '@/views/pt/teacher-report/components/exercise-content.vue'),
  },
  // 试题篮
  {
    path: '/pt/question-basket',
    name: 'QuestionBasket',
    component: () => import(/* webpackChunkName: "question-basket" */ '@/views/pt/exercise-center/question-basket.vue'),
  },
  // 发布MT作业
  {
    path: '/pt/publish-mt',
    name: 'PublishMt',
    component: () => import(/* webpackChunkName: "publish-mt" */ '@/views/pt/exercise-center/components/publish-mt.vue'),
  },
  // 发布作业成功
  {
    path: '/pt/publish-success',
    name: 'PublishSuccess',
    component: () => import(/* webpackChunkName: "publish-success" */ '@/views/pt/exercise-center/components/publish-success.vue'),
  },
  // 查看题目资源
  {
    path: '/pt/preview-resource',
    name: 'PreviewResource',
    component: () => import(/* webpackChunkName: "preview-resource" */ '@/views/pt/exercise-center/preview-resource.vue'),
  },
  // 打印练习中心试题
  {
    path: '/pt/export-question',
    name: 'ExportQuestion',
    component: () => import(/* webpackChunkName: "export-question" */ '@/views/pt/exercise-center/components/export-question.vue'),
  },
  // 薄弱知识点布置页面
  {
    path: '/pt/publish-weak-point',
    name: 'PublishWeakPoint',
    component: () => import(/* webpackChunkName: "export-question" */ '@/views/pt/exercise-center/components/publish-weak-point.vue'),
  },
  // 教育云平台
  {
    path: '/pt/exhibition',
    name: 'Exhibition',
    component: () => import(/* webpackChunkName: "export-question" */ '@/views/pt/exhibition/index.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes,
});

export default router;
